import axios from 'axios'
import { API_DEFAULT_TIMEOUT_MS } from '@/utils/constants'

const proxyClient = axios.create({
  baseURL: process.env.MY_URL,
  timeout: API_DEFAULT_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

export const client = proxyClient



// WEBPACK FOOTER //
// ./src/api/vercelServerless/client.js